var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"centered":"","title":"Get XOME Instructions"},on:{"ok":_vm.getInstructions}},[_vm._v(" Getting instructions will invalidate existing credentials. Would you like to continue? ")])}
var staticRenderFns = []

export { render, staticRenderFns }